import { topicsData, featuresData, rankingData } from '@/mocks/homeData';

export function SectionTopics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          大家都在讨论的漫画话题，看看有没有你感兴趣的
        </p>
        <div className="mt-8 md:mt-10 flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector(item.href);
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="group flex items-center gap-2.5 px-4 py-3 md:px-5 md:py-3.5 bg-background-100 hover:bg-primary-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap transition-colors">
                {item.tag}
              </span>
              <span className="text-xs text-accent-600 bg-accent-100/70 px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
                {item.heat}热度
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionFeatures() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          为什么选择亲亲漫画
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          五大核心优势，为你打造极致漫画阅读体验
        </p>
        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100/70 group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionRanking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          热门榜单
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          全网读者都在追的热门漫画，实时热度排行
        </p>

        <div className="mt-8 md:mt-10 max-w-[720px] mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 md:gap-5 p-4 md:p-5 bg-background-50 border-b border-background-200/60 hover:bg-background-100/60 transition-colors cursor-pointer last:border-b-0 rounded-lg"
            >
              <span className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg text-sm font-bold whitespace-nowrap ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-secondary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    《{item.title}》
                  </h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100/70 text-primary-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">{item.chapter}</p>
              </div>

              <div className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                <i className="ri-eye-line"></i>
                <span>{item.reads}阅读</span>
              </div>

              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#cards');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="hidden sm:inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 hover:bg-primary-100 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                查看详情
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}